var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelfie(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 2,
    fill: "#EFF0F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.298 20.734C17.682 20.916 16.954 21 16.1 21H11.9C11.046 21 10.318 20.916 9.70199 20.734C9.85599 18.914 11.725 17.479 14 17.479C16.275 17.479 18.144 18.914 18.298 20.734Z",
    stroke: "#292D32",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1 7H11.9C8.4 7 7 8.4 7 11.9V16.1C7 18.746 7.798 20.195 9.702 20.734C9.856 18.914 11.725 17.479 14 17.479C16.275 17.479 18.144 18.914 18.298 20.734C20.202 20.195 21 18.746 21 16.1V11.9C21 8.4 19.6 7 16.1 7ZM14 15.519C12.614 15.519 11.494 14.392 11.494 13.006C11.494 11.62 12.614 10.5 14 10.5C15.386 10.5 16.506 11.62 16.506 13.006C16.506 14.392 15.386 15.519 14 15.519Z",
    stroke: "#292D32",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.506 13.006C16.506 14.392 15.386 15.519 14 15.519C12.614 15.519 11.494 14.392 11.494 13.006C11.494 11.62 12.614 10.5 14 10.5C15.386 10.5 16.506 11.62 16.506 13.006Z",
    stroke: "#292D32",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfie);
export default __webpack_public_path__ + "static/media/selfie.d31d26e1.svg";
export { ForwardRef as ReactComponent };